(() => {
  function formatArticles(root) {
    root.querySelectorAll('.journal-article__body').forEach((body) => {
      body.querySelectorAll('iframe[src]').forEach((frame) => {
        const source = new URL(frame.getAttribute('src'), window.location.origin);
        if (source.hostname !== 'www.goodmorningamerica.com') return;
        const originalLink = [...body.querySelectorAll('a[href]')].find((link) => {
          const destination = new URL(link.href);
          return destination.hostname === source.hostname;
        });
        const link = document.createElement('a');
        link.href = originalLink ? originalLink.href : source.href;
        link.textContent = body.dataset.videoLabel;
        link.className = 'journal-article__video-link';
        link.target = '_blank';
        link.rel = 'noopener';
        const paragraph = document.createElement('p');
        paragraph.append(link);
        body.append(paragraph);
        frame.remove();
      });
      [...body.children].forEach((element) => {
        if (element.tagName === 'P' && !element.textContent.trim() &&
            !element.querySelector('img, video, iframe, audio, svg, canvas, object')) {
          element.remove();
        }
      });
      const first = body.firstElementChild;
      if (first?.tagName === 'P' && first.children.length === 1 &&
          first.firstElementChild.tagName === 'STRONG' &&
          first.textContent.trim() === first.firstElementChild.textContent.trim()) {
        first.classList.add('journal-article__lead');
      }
    });
  }
  formatArticles(document);
  document.addEventListener('shopify:section:load', (event) => formatArticles(event.target));
})();
